import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "./App";
import "./index.css";
import "./i18n"; // must be imported before any component that uses translations
import HomePage from "./pages/home/HomePage";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";
import { Provider } from "react-redux";
import store from "./store";
// @ts-ignore
import ReduxToastr from "react-redux-toastr";
import "react-slidedown/lib/slidedown.css";
import PrivacyPolicyPage from "pages/privacyPolicy/privacyPolicyPage";
import TermsAndConditionsPage from "pages/termsAndConditions/termsAndConditionsPage";
import ContactPage from "pages/contact/contactPage";
import AvailableDomainsPage from "pages/availableDomains/AvailableDomainsPage";
import ExpiredDomainsPage from "pages/expiredDomains/ExpiredDomainsPage";
import DomainPage from "pages/domain/domainPage";
import NotFoundPage from "pages/notFound/NotFoundPage";

const rootElement = document.getElementById("root") as HTMLElement;

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "",
        element: <HomePage />,
      },
      {
        path: "domain/:domain",
        element: <DomainPage />,
      },
      {
        path: "expired-domains",
        element: <ExpiredDomainsPage />,
      },
      {
        path: "available-domains",
        element: <AvailableDomainsPage />,
      },
      {
        path: "privacy-policy",
        element: <PrivacyPolicyPage />,
      },
      {
        path: "terms-and-conditions",
        element: <TermsAndConditionsPage />,
      },
      {
        path: "contact",
        element: <ContactPage />,
      },
    ],
  },
  // Spanish locale — mirrors all routes except domain pages (those fall back to English)
  {
    path: "/es",
    element: <App />,
    children: [
      {
        path: "",
        element: <HomePage />,
      },
      {
        path: "expired-domains",
        element: <ExpiredDomainsPage />,
      },
      {
        path: "available-domains",
        element: <AvailableDomainsPage />,
      },
      {
        path: "privacy-policy",
        element: <PrivacyPolicyPage />,
      },
      {
        path: "terms-and-conditions",
        element: <TermsAndConditionsPage />,
      },
      {
        path: "contact",
        element: <ContactPage />,
      },
    ],
  },
  // Chinese (Simplified) locale — mirrors all routes except domain pages (those fall back to English)
  {
    path: "/zh-CN",
    element: <App />,
    children: [
      {
        path: "",
        element: <HomePage />,
      },
      {
        path: "expired-domains",
        element: <ExpiredDomainsPage />,
      },
      {
        path: "available-domains",
        element: <AvailableDomainsPage />,
      },
      {
        path: "privacy-policy",
        element: <PrivacyPolicyPage />,
      },
      {
        path: "terms-and-conditions",
        element: <TermsAndConditionsPage />,
      },
      {
        path: "contact",
        element: <ContactPage />,
      },
    ],
  },
  // Catch-all 404 route
  {
    path: "*",
    element: <App />,
    children: [
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
]);

const AppProvider = () => (
  <Provider store={store}>
    {/* @ts-ignore */}
    <RouterProvider router={router} />
    <ReduxToastr
      timeOut={5000}
      newestOnTop={false}
      preventDuplicates
      position="bottom-right"
      transitionIn="fadeIn"
      transitionOut="fadeOut"
      progressBar
      closeOnToastrClick
    />
  </Provider>
);

// Use hydration for pre-rendered pages, otherwise use normal render
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, <AppProvider />);
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(<AppProvider />);
}

reportWebVitals();
